import moment from 'moment-timezone';
import { Moment } from 'moment';
import { formatQueryString } from '../../../Services/Api/FormatQueryString';
import apiClient from '../../../Services/ApiClient';

export interface Questionnaire {
	id: string;
	code: string;
	createdAt: string;
	deletedAt: string;
	parentQuestionnaireId: string;
	partnerId: string;
	title: string;
	type: string;
}

export interface Source {
	code: string;
	title: string;
}

export interface HealthDataItem {
	id: string;
	measure_name: string;
	questionnaire?: Questionnaire;
	questionnaireItemId?: string;
	scope: string;
	source: Source;
	time: Moment;
	token: string;
	userId: string;
	value: string;
	minWidth?: string;
	maxWidth?: string;
	textColor?: string;
	backgroundColor?: string;
}

export interface IHealthData {
	data: HealthDataItem[];
	description: string;
	key: string;
	unit: string;
	roundValuesTo?: number;
	renderEmpty?: ({ item }: any) => void;
}

export default function useHealthData() {
	const getHealthData = async (
		patientId: string,
		view: string,
		range: { from: Date | Moment; to: Date | Moment },
		source: string[],
		keys: string[],
		type: string,
	) => {
		let query = formatQueryString({
			view: view,
			start: range.from.toISOString(),
			end: range.to.toISOString(),
			source: source,
			keys: keys,
			type: type,
		});

		const { data } = await apiClient.get(
			'/user/' + patientId + '/health-data/chart?' + query,
			{ timeout: 30000 },
		);

		return transformToUserTimezone(data);
	};

	const filterHealthDataByKeys = (data: IHealthData[], keys: string[]) => {
		if (data) {
			return data.filter(({ key }) => keys.includes(key));
		} else {
			return null;
		}
	};

	const filterKeys = (filterKeys: string[], datasetKeys: string[]) => {
		return filterKeys.filter((f: string) => datasetKeys.includes(f));
	};

	const transformToUserTimezone = (data: IHealthData[]) => {
		data.forEach((healthData, index) => {
			healthData.data.forEach((item, index2) => {
				const time = moment.utc(item.time);
				data[index].data[index2]['id'] = time.format('x');
				data[index].data[index2]['time'] = time;
			});
		});

		return data;
	};

	return { getHealthData, filterHealthDataByKeys, filterKeys };
}
